import React from "react"
import { Container } from "reactstrap"
import Layout from "../../components/layout"
import { Helmet } from "react-helmet"
import { Banner, TeamCollection } from "@igloonet-web/shared-ui"
import { useActiveEmployees } from "../../hooks/use-active-employees"
import ProfileImage from "../../components/profile-image"

export default function Tym() {
  const employees = useActiveEmployees()

  return (
    <Layout>
      <Helmet>
        <title>Tučňáci v administrativě | igloonet</title>
        <meta
          name="description"
          content="Kdo vám pošle fakturu, na kterou se těšíte? Seznamte se s úžasným týmem administrativy."
        />
      </Helmet>
      <Banner>
        <h1>Tučňáci v administrativě</h1>
      </Banner>

      <Container className="text-center">
        <TeamCollection
          imageTag={ProfileImage}
          teamMembers={employees.filter((e) => e.division === "administrativa")}
        />
      </Container>
    </Layout>
  )
}
